import { render } from "./paidCanvas.vue?vue&type=template&id=4e45653a&scoped=true"
import script from "./paidCanvas.vue?vue&type=script&lang=js"
export * from "./paidCanvas.vue?vue&type=script&lang=js"

import "./paidCanvas.vue?vue&type=style&index=0&id=4e45653a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e45653a"]])

export default __exports__